import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import { combineClasses } from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ButtonBase.scss';

/**
 * ButtonBase contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 */
function ButtonBase(props) {
    const {
        classes: classesProp = {},
        className,
        component: ComponentProp = 'button',
        componentProps,
        disabled = false,
        onClick = () => undefined,
        tabIndex = 0,
        type = 'button',
        ...otherProps
    } = props;

    let Component = ComponentProp;
    const buttonProps = {};
    if (Component === 'button' && otherProps.href) {
        Component = 'a';
    }

    if (Component === 'button') {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (Component !== 'a' || !otherProps.href) {
            buttonProps.role = 'button';
        }
        buttonProps['aria-disabled'] = disabled;
    }

    const classes = combineClasses(styles, classesProp);

    return (
        <Component
            className={clsx(
                classes.root,
                { [classes.disabled]: disabled },
                className,
            )}
            onClick={onClick}
            tabIndex={disabled
                ? -1
                : tabIndex}
            {...buttonProps}
            {...otherProps}
            {...componentProps}
        />
    );
}

ButtonBase.propTypes = {
    /**
     * The content of the component.
     */
    children: PropTypes.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * The component used for the root node.
     * Either a string to use a HTML element or a component.
     */
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    /**
     * If `true`, the base button will be disabled.
     */
    disabled: PropTypes.bool,
    /**
     * @ignore
     */
    href: PropTypes.string,
    onClick: PropTypes.func,
    /**
     * @ignore
     */
    tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
     * @ignore
     */
    type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string]),
};

export default ButtonBase;
